import axios from "axios";
import { useMutation } from "react-query";
import { IUpdateTProfile } from "../types";
import { END_POINT } from "config/environment";

export const updateTalentProfile = async (props: IUpdateTProfile) => {
  const url = `${END_POINT.BASE_URL}/v1/update-talent-profile`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
      "Content-Type": "multipart/form-data"
    },
  };
  

  const formData = new FormData();
  formData.append("first_name", props.first_name);
  formData.append("last_name", props.last_name);
  formData.append("middle_name", props.middle_name);
  formData.append("open_to_work", props.open_to_work ? "1" : "0");
  formData.append("relocate", props.relocate ? "1" : "0");
  formData.append("gender", props.gender);
  formData.append("executive_summary", props.executive_summary);
  formData.append("professional_goal", props.professional_goal);
  formData.append("phone", props.phone);
  formData.append("country", props.country);
  formData.append("city", props.city);
  const skills = Array.isArray(props.skills) ? props.skills : [];
  
  skills.forEach(skill => {
    formData.append("skills[]", skill);
  });
  const languages = Array.isArray(props.language) ? props.language : [];
  languages.forEach(language => {
    formData.append("language[]", language);
  });
  
  formData.append("sector_id", props.sector_id);
  formData.append("experience_level", props.experience_level);
  formData.append("prefered_industries", props.prefered_industries);
  formData.append("prefered_locations", props.prefered_locations);
  formData.append("current_position", props.current_position);
  formData.append("linkedin", props.linkedin);
  formData.append("github", props.github);
  formData.append("behance", props.behance);
  formData.append("facebook", props.facebook);
  formData.append("x", props.x);
  formData.append("photo", props.photo);
  formData.append("cover_photo", props.cover_photo);
  formData.append("instagram", props.instagram);
  if (props.portfolio !== undefined) {
    formData.append("portfolio", props.portfolio);
  }
  formData.append("current_location", props.current_location);

  const response = await axios.post(url, formData, config);
  return response;
};

export const useUpdateTalentProfile = () => {
  return useMutation(updateTalentProfile);
};
